module.exports = __webpack_public_path__ + "img/hands.71019eff.png";